import { ArrowButton } from "@/components/ui";
import { mapGetters } from "vuex";
export default {
	name: "CategoryCard",
	components: {
		ArrowButton,
	},
	data() {
		return {};
	},
	props: ["title", "slug", "image", "sectors", "id", "isScreen", "hide_label"],
	methods: {
		selectSector(sector) {
			if (sector.is_disabled) {
				return; 
			}
			this.$emit('sectorSelected', sector);
			this.$router.push({
				name: "SectorScreen",
				params: { category: this.slug, sector: sector.slug },
			});
		},
	},
	computed: {
		...mapGetters("staticContent", ["getTranslations"]),
	},
};
